// Shared fetch wrapper for the Lens API. Every domain client uses this.
// Handles token acquisition, JSON serialization, and error normalization.
import { acquireLensApiToken } from "../auth/msal";

export async function api<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = await acquireLensApiToken();
  const res = await fetch(path, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail: string;
    try {
      const j = await res.json();
      detail = j.message ?? JSON.stringify(j);
    } catch {
      detail = await res.text();
    }
    throw new Error(`${method} ${path} → ${res.status}: ${detail}`);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
